<template>
  <div class="press">
    <div class="campus">电商管理
      <span>></span>
      课程管理
    </div>

    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="header">全部课程</div>
          <p class="prompt">
            <i class="el-icon-warning"></i>小程序里所有类型的课程都在此处新建，您可设置新建的课程是免费还是付费，以及课程标签及更多课程的有关设置
          </p>
          <el-form ref="forms" :model="forms" :rules="FormRules" label-width="300px">
            <el-form-item label="课程名称:" prop="name">
              <el-input v-model="forms.name" placeholder="请输入课程名称" rows="9" style="width:560px; marginRight:20px;" disabled></el-input>
            </el-form-item>
            <el-form-item label="课程封面:" prop="picurl">
              <div class="course_cover">
                <img :src="forms.picurl" class="avatar mt-10" />
              </div>
            </el-form-item>
            <el-form-item label="课程类型:" prop="abbreviation">
              <el-select v-model="forms.abbreviation" @change="onSelectedDrug($event)" disabled>
                <el-option v-for="(item) in typeList" :key="item.id" :label="item.value" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="课程价格:" prop="price">
              <el-input v-model="forms.price" placeholder="请输入价格" rows="9" style="width:560px;" disabled @onkeyup="this.value=this.value.replace(/[^0-9,.]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="课程标签:" prop="discount">
              <el-checkbox-group v-model="forms.label" disabled>
                <el-checkbox v-for="(item) in labelList" :key="item.id" :label="item.id" :value="item.id">
                  <span :style="{'color':item.fontColor,'background':item.backgroundColor,}">{{item.name}}</span>
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="推荐指数:" prop="classhot">
              <el-input-number disabled v-model="forms.hot" :min="0" :max="10000" @onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"></el-input-number>
            </el-form-item>
            <el-form-item label="课程数量:" prop="number">
              <el-input-number disabled v-model="forms.number" :min="0" :max="99999999" @onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"></el-input-number>
            </el-form-item>
            <el-form-item label="介绍视频:" prop="videoUrl">
              <div class="intruduce_video"><video class="avatar mt-10" :src="forms.videoUrl" autoplay></video> <span>{{videoName}}</span></div>
            </el-form-item>
            <el-form-item label="课程信息:" prop="shortname">
              <el-input type="textarea" disabled v-model="forms.shortname" style="width:560px;" placeholder="请输入课程简介" resize="none"></el-input>
            </el-form-item>
            <el-form-item label="课程详情:" prop="coursedetails">
              <div class="intruduce_img">
                <quill-editor ref="text" style="margin-bottom:10px" v-model="forms.details" :options="editorOption" disabled />
              </div>
            </el-form-item>
            <el-form-item label="课程目录:" prop="coursedetails">
            </el-form-item>
            <div class="tableStyle">
              <el-table :data="tableData" style="width: 70%;marginLeft:300px;">
                <el-table-column prop="seqNum" label="目录序号" align="center">
                </el-table-column>
                <el-table-column prop="name" label="目录名称" align="center">
                </el-table-column>
                <el-table-column prop="stock" label="目录视频" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.videoUrl"><video width="60" :src="scope.row.videoUrl"></video></span>
                    <span v-else>未添加视频</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>

          </el-form>
        </div>
        <el-button type="primary" style="width:200px;margin:30px 600px;" @click="comeback" round>返回列表</el-button>

      </el-card>
    </div>

  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
const FormRules = {
  name: [
    {
      required: true,
      message: '请输入课程名称',
      trigger: ['blur', 'change'],
    },
  ],
  price: [
    {
      required: true,
      message: '请输入价格',
      trigger: ['blur', 'change'],
    },
  ],
  number: [
    {
      required: true,
      message: '请选择或输入数量',
      trigger: ['blur', 'change'],
    },
  ],
  abbreviation: [
    {
      required: true,
      message: '请选择类型',
      trigger: ['blur', 'change'],
    },
  ],
};
export default {
  components: { quillEditor },
  data() {
    return {
      FormRules,
      searchName: '',
      tableData: [],
      // 检索表单数据对象
      page: 1,
      pageSize: 10,
      total: 0,
      videoName: '',
      classtypes: '',
      chooseClass: [],
      labelList: [],
      typeList: [
        {
          value: '综合课程',
          id: 1,
        },
        {
          value: '专项课程',
          id: 2,
        },
      ],
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            ['blockquote', 'code-block'],
            ['image'],
          ],
        },
      },
      publicDialog: false,
      sceondkillId: '',
      dialogType: '',
      courseId: '',
      typeLabelValue: '',
      forms: {
        abbreviation: '',
        name: '',
        number: '',
        label: [],
        shortname: '',
        cataloguename: '',
        catalogueseqNum: '',
        cataloguevideo: '',
        price: '',
        catalogueId: '',
        details: '',
        catalogue: '',
        picurl: '',
        videoUrl: '',
        hot: '',
        discount: '',
      },
    };
  },
  created() {
    if (Boolean(this.$route.query.id) == true) {
      this.lookcourse();
    }
  },
  methods: {
    comeback() {
      this.$router.go(-1);
    },
    //查看目录
    editcatalogue(row) {
      this.dialogType = 1;
      this.catalogueId = row.id;
      this.publicDialog = true;
      this.forms.cataloguename = row.name;
      this.forms.catalogueseqNum = row.seqNum;
      this.forms.cataloguevideo = row.videoUrl;
    },
    //查看课程
    lookcourse() {
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course/' + this.$route.query.id,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            let data = result.data.data;
            this.forms.name = data.name;
            this.forms.picurl = data.coverUrl;
            this.typeLabelValue = data.type;
            this.forms.price = data.price;
            this.forms.hot = data.hot;
            this.forms.abbreviation = data.type;
            this.forms.videoUrl = data.videoUrl;
            this.forms.details = data.detail;
            this.forms.shortname = data.desc;
            this.forms.number = data.stock;
            this.tableData = data.dirs;
            for (let i = 0; i < data.labels.length; i++) {
              this.forms.label.push(data.labels[i].id);
            }
            console.log(this.forms.label);
            this.queryLabel();
          }
        })
        .catch((err) => {
          this.$message.error('查询失败：' + err);
        });
    },
    //查询标签
    queryLabel() {
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course/label/type/' + this.forms.abbreviation,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.labelList = result.data.data;
          }
        })
        .catch((err) => {
          this.$message.error('查询失败：' + err);
        });
    },
    //选择
    handleSelectionChange: function (val) {
      var id = [];
      for (let i = 0; i < val.length; i++) {
        id.push(val[i].id);
      }
      this.chooseClass = id;
    },
    onSelectedDrug(e) {
      this.typeLabelValue = e;
      this.queryLabel();
    },
  },
};
</script>

<style lang="less" scoped>
.press {
  .prompt {
    width: 100%;
    height: 2rem;
    background-color: rgba(246, 98, 0, 0.1);
    color: rgba(246, 98, 0, 0.8);
    line-height: 2rem;
    padding-left: 20px;
  }
  .el-input__inner {
    width: 100% !important;
  }
  .intruduce_video {
    width: 560px;
    height: 160px;
    border: 1px solid #cccccc;
    video {
      width: 300px;
      height: 120px;
    }
  }
  .intruduce_img {
    width: 750px;
    max-height: 300px;
    overflow: auto;
    .quill-editor {
      width: 100%;
      height: 85%;
    }
  }
  .course_cover {
    width: 100px;
    height: 100%;
    border: 1px solid;
    img {
      width: 100%;
    }
  }
  .jianyi {
    font-size: 12px !important;
    color: #cccccc;
    position: absolute;
    top: 0;
    left: 200px;
  }
  .el-button--text:active {
    color: #00a6e6;
  }
  .el-button--text {
    color: #00a6e6;
  }
  .avatar {
    width: 200px;
  }
  .el-dialog__body {
    height: 500px;
  }
  .avatar-uploader {
    position: absolute;
    top: -10px;
    right: 640px;

    img {
      width: 100px;
      height: 100px;
    }
  }
  .class_type {
    display: inline-block;
    margin-left: 400px;
  }
  /deep/.el-upload {
    text-align: left;
  }
  .tableImg {
    width: 80px;
    height: 80px;
  }
  /deep/.el-card__body {
    padding: 0 1.3vw;
  }
  .course_label {
    display: inline-block;
    margin-left: 10px;
    padding: 0 10px;
  }
  /deep/.el-input.is-disabled .el-input__inner {
    color: #606266;
  }
  /deep/.el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
  /deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #409eff;
  }
}
</style>
